// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full screen dark background */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black */
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center;     /* Center vertically */
  z-index: 9999;           /* Ensure it's above everything else */
  backdrop-filter: blur(4px); /* Optional: blurs the background content */
}

/* The actual modal box */
.modal {
  background: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  text-align: center;
  animation: fadeInScale 0.3s ease-out; /* Smooth entrance */
}

.modal h3 {
  margin-top: 0;
  color: #d32f2f; /* Error red color */
  font-size: 1.5rem;
}

.modal p {
  color: #555;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.modal button {
  background-color: #1976d2; /* Material Blue */
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.modal button:hover {
  background-color: #1565c0;
}

/* Entrance Animation */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,2BAA2B;EACjE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,MAAM,sBAAsB;EAC/C,aAAa,YAAY,sCAAsC;EAC/D,0BAA0B,EAAE,2CAA2C;AACzE;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC,EAAE,oBAAoB;AAC5D;;AAEA;EACE,aAAa;EACb,cAAc,EAAE,oBAAoB;EACpC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* Full screen dark background */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black */\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center;     /* Center vertically */\n  z-index: 9999;           /* Ensure it's above everything else */\n  backdrop-filter: blur(4px); /* Optional: blurs the background content */\n}\n\n/* The actual modal box */\n.modal {\n  background: #ffffff;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 400px;\n  text-align: center;\n  animation: fadeInScale 0.3s ease-out; /* Smooth entrance */\n}\n\n.modal h3 {\n  margin-top: 0;\n  color: #d32f2f; /* Error red color */\n  font-size: 1.5rem;\n}\n\n.modal p {\n  color: #555;\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n}\n\n.modal button {\n  background-color: #1976d2; /* Material Blue */\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.modal button:hover {\n  background-color: #1565c0;\n}\n\n/* Entrance Animation */\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
